import { Outlet } from 'react-router-dom'
import KycProvider from '@/kyc/KycProvider'
import { TradeModalProvider } from '@/trading/TradeModalProvider'
import useAccountStore from '@/account/accountStore'
import { FullScreenLoader } from '@/common/ui/FullScreenLoader'

export const TradingAccountContainer = () => {
    const { activeAccountId, isAccountSwitching } = useAccountStore((s) => ({
        activeAccountId: s.activeAccountId,
        isAccountSwitching: s.isAccountSwitching,
    }))

    // Guard trading routes until account context settles to avoid null-account API calls.
    if (!activeAccountId || isAccountSwitching) {
        return <FullScreenLoader dark />
    }

    return (
        <KycProvider>
            <TradeModalProvider>
                <Outlet />
            </TradeModalProvider>
        </KycProvider>
    )
}
